import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, FormHelperText, Switch } from '@mui/material'
import FormControl from '@mui/material/FormControl'

/**
 * A switch component that uses MUI's Switch component
 * @param {Object} props - Component props
 * @param {boolean} props.checked - Whether the switch is checked
 * @param {function} props.onChange - Function to call when the switch value changes
 * @param {string} props.label - Label for the switch
 * @param {string} props.labelPlacement - Placement of the label (start, end, top, bottom)
 * @param {Object} props.sx - Custom styles
 * @returns {JSX.Element} - Rendered component
 */
const HHMuiSwitch = ({ checked = false, labelPlacement = 'end', onChange, label, sx, error = false, helperText, ...rest }) => {
  // If there's a label, wrap the switch in a FormControlLabel
  if (label) {
    return (
      <FormControl>
        <FormControlLabel
          control={<Switch checked={checked} onChange={e => onChange(e.target.checked, e)} {...rest} />}
          label={label}
          labelPlacement={labelPlacement}
          sx={sx}
        />
        {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
      </FormControl>
    )
  }

  // Otherwise, just return the switch
  return <Switch checked={checked} onChange={e => onChange(e.target.checked, e)} sx={sx} {...rest} />
}

HHMuiSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelPlacement: PropTypes.oneOf(['start', 'end', 'top', 'bottom']),
  sx: PropTypes.object,
}

export default HHMuiSwitch
